import React, { ReactNode } from 'react';
import { FormItemProps, TimePicker, TimePickerProps } from 'antd';
import { JInputWrapper } from '../JInputWrapper';

export type JTimePickerProps = {
  /**
   * Action to update external module
   * @param value
   */
  onChange?: (e: any) => void;
  /**
   * label
   */
  label?: ReactNode;

  /**
   * name
   */
  name?: string | number | (string | number)[];
  /**
   * Time format
   */
  format?: string;
  /**
   * Default Value
   */
  defaultValue?: any;
  /**
   * Default open Value
   */
  defaultOpenValue?: any;

  /**
   * disabled
   */
  disabled?: boolean;

  /**
   * ant design Form.Item props
   * https://ant.design/components/form/#API
   */
  itemProps?: FormItemProps;

  /**
   * ant design Input props
   * https://ant.design/components/time-picker/#API
   */
  timePickerProps?: TimePickerProps;
};

export const JTimePicker = ({
                              label,
                              name,
                              format = 'HH:mm',
                              defaultValue,
                              defaultOpenValue,
                              disabled,
                              onChange,
                              itemProps,
                              timePickerProps,
                            }: JTimePickerProps) => {
  return (<>      {label ?
          <JInputWrapper label={label} name={name} {...itemProps}>
            <TimePicker
                disabled={disabled}
                onChange={(e) => (onChange ? onChange(e) : '')}
                defaultValue={defaultValue}
                defaultOpenValue={defaultOpenValue}
                format={format}
                {...timePickerProps}
            />
          </JInputWrapper>:
          <TimePicker
              disabled={disabled}
              onChange={(e) => (onChange ? onChange(e) : '')}
              defaultValue={defaultValue}
              defaultOpenValue={defaultOpenValue}
              format={format}
              {...timePickerProps}
          />
      }
      </>
  );
};
